import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
   selector: 'app-title',
   standalone: true,
   imports: [CommonModule],
   templateUrl: './title.component.html',
   styleUrls: ['./title.component.scss']
})
export class TitleComponent {
   @Input() title: string = '';
   @Input() fontColor: string = 'black';
}
